/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect } from 'react';
import PostHeader from 'components/PostHeader';
import ImageSlider from 'containers/ImageSlider';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { convertUnitsOfMeasurement } from 'utils/convertUnitsOfMeasurement';
import { GetSettings } from 'services';
import { useSelector } from 'react-redux';
import { likePost, unlikePost } from 'services/likePost';
import SocialActivity from 'components/SocialActivity';
import { VerticalDashedLine } from '../../pages/map/components/index';
import {
  FinishLocationIcon,
  StartLocationIcon,
  RouteDistanceIcon,
  RouteTimeIcon,
} from '../../pages/map/icons';
import {
  RouteWrap,
  RouteName,
  WaypointWrap,
  WaypointName,
} from '../../pages/map/components/SidebarSavedRoutes/SidebarSavedRoutes.style';
import {
  RouteKm,
  RouteDistance,
  RouteTime,
} from '../../containers/TopEvents/TopRoutes.style';
import { FeedPostWrapper, SocialActivityBlock } from './FeedPhotoPost.styles';

const RoutePhotoPost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  isFavorite,
  followingStatus,
  postTime,
  origin,
  id,
  originId,
  type,
  data,
  postData,
  onCommentClick,
}: any) => {
  const { t } = useTranslation();
  const [units, setUnits] = useState<Boolean>();
  const userDetails = useSelector((store) => store.user?.userDetails);

  useEffect(() => {
    GetSettings(userDetails?._id).then((res) => {
      setUnits(res?.units);
    });
  }, [userDetails]);

  const router = useRouter();
  const route = postData?.routeDetails;
  const photo = postData?.routeDetails?.staticImageUrl;
  const checkMedia: any = photo
    ? [
        {
          type: 'image/jpeg',
          url: photo,
          dimensions: {},
        },
      ]
    : [];

  const onRouteClick = (routeId) => {
    router.push(`/r/${routeId}`);
  };

  const { isLike, likes, commentsCount, sharesCount } = postData;

  const [postLike, setPostLike] = useState<boolean>(isLike);
  const [likesCount, setLikesCount] = useState<number>(likes || 0);
  const [isProfilePhotoUrlCopied, setIsProfilePhotoUrlCopied] =
    useState<boolean>(false);

  const onLikePost = (id) => {
    setPostLike(!postLike);
    if (postLike) {
      unlikePost(id).then((res) => {});
      setLikesCount(likesCount - 1);
      return;
    }
    likePost(id).then((res) => {});
    setLikesCount(likesCount + 1);
  };

  return (
    <FeedPostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isFavorite={isFavorite}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={type}
        id={id}
        origin={origin}
        originId={originId}
        data={data || postData}
        favoriteOption
      />
      <div onClick={() => onRouteClick(route._id)}>
        <div>
          <ImageSlider images={checkMedia} alt="photo post" variantToUse="" />
        </div>
        <div style={{ padding: '2%' }}>
          <SocialActivityBlock>
            <RouteWrap>
              <RouteName>{route.name}</RouteName>
              <WaypointWrap>
                <StartLocationIcon />
                <WaypointName>{route.waypoints[0].waypointName}</WaypointName>
              </WaypointWrap>
              <VerticalDashedLine margin="0 0 0 11px" />
              <WaypointWrap>
                <FinishLocationIcon />
                <WaypointName>{route.waypoints[1].waypointName}</WaypointName>
              </WaypointWrap>
            </RouteWrap>
            <RouteKm>
              <RouteDistance>
                <RouteDistanceIcon />
                <span>
                  {!units
                    ? convertUnitsOfMeasurement(route?.distance / 1000, false)
                    : Math.round(route?.distance / 1000)}{' '}
                  {units ? t('common:km') : t('common:mi')}
                </span>
              </RouteDistance>
              <RouteTime>
                <RouteTimeIcon />
                <span>
                  {Math.floor(route?.time / 3600) || 0} {t('common:h')}{' '}
                  {Math.floor((route?.time % 3600) / 60) || 0} {t('common:min')}
                </span>
              </RouteTime>
            </RouteKm>
          </SocialActivityBlock>
        </div>
      </div>

      <div>
        <SocialActivity
          id={id}
          originId={originId}
          onCommentClick={(id) => onCommentClick(id)}
          onLikeClick={(id) => onLikePost(id)}
          commentsNumber={commentsCount}
          sharesNumber={sharesCount}
          likesNumber={likesCount}
          isLike={postLike}
          postType={type}
          type="reward"
          isUrlCopied={isProfilePhotoUrlCopied}
          setIsUrlCopied={setIsProfilePhotoUrlCopied}
        />
      </div>
    </FeedPostWrapper>
  );
};

export default RoutePhotoPost;
